import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getCurrentAccount, signOut, getAccessToken } from "../azure-auth";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from "@mui/material";
import { URL } from "../urls";
import Footer from "./Footer";
import "../uiux.css";
import Header from "./Header";

const AskEnterprise = () => {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [openAlert, setOpenAlert] = useState(false);
  const [askEnterpriseUrl, setAskEnterpriseUrl] = useState("");

  const handleCloseAlert = () => {
    setOpenAlert(false);
  };

  useEffect(() => {
    const account = getCurrentAccount();
    if (!account) {
      navigate("/");
    } else {
      setUser(account);
    }
    setLoading(false);
  }, [navigate]);

  useEffect(() => {
    const fetchAskEnterpriseUrl = async () => {
      try {
        const token = await getAccessToken();
        const userEmail = user ? (user.userName || user.username || user.email) : "";
        const userOID = user ? (user.localAccountId || user.oid) : "";

        const headers = { "Content-Type": "application/json" };
        if (token) headers["Authorization"] = `Bearer ${token}`;
        else {
          if (userEmail) headers["X-User-Email"] = userEmail;
          if (userOID) headers["X-User-Id"] = userOID;
        }

        const response = await fetch(URL.GET_TOKEN_ASKENTERPRISE, { headers });
        const data = await response.json();
        if (data?.url) {
          setAskEnterpriseUrl(data.url);
        }
      } catch (error) {
        console.error("Failed to fetch Ask Enterprise URL:", error);
      }
    };

    if (user) {
      fetchAskEnterpriseUrl();
    }
  }, [user]);

  const handleLogout = async () => {
    try {
      await signOut();
      navigate("/");
    } catch (err) {
      console.error("Logout error:", err);
    }
  };

  if (loading) return <div>Loading...</div>;
  if (!user) return null;

  return (
    <div className="chatbot-container chat-fit-screen">
      <Header/>

      <h1 className="chatbot-title">Ask Enterprise</h1>
      <p
        style={{
          marginTop: "-6px",
          marginBottom: "14px",
          color: "rgba(255,255,255,0.85)",
          textAlign: "center",
          fontSize: "16px",
          maxWidth: "780px",
          width: "92%",
          marginLeft: "auto",
          marginRight: "auto",
        }}
      >
        Welcome to Ask Enterprise for business support and enterprise-related assistance.
      </p>

      <div
        style={{
          width: "92%",
          maxWidth: "1100px",
          flex: 1,
          maxHeight: "calc(100vh - 320px)",
          minHeight: 0,
          borderRadius: "16px",
          overflow: "hidden",
          margin: "0 auto 12px auto",
          display: "flex",
          flexDirection: "column",
          background: "rgba(0, 0, 0, 0.35)",
          backdropFilter: "blur(18px)",
          WebkitBackdropFilter: "blur(18px)",
          border: "1px solid rgba(255, 255, 255, 0.12)",
          boxShadow: "0 8px 32px rgba(0,0,0,0.5), 0 0 12px rgba(0,173,255,0.35), 0 0 24px rgba(255,0,255,0.25)",
        }}
      >
        <iframe
          title="Ask Enterprise"
          src={askEnterpriseUrl}
          style={{ width: "100%", height: "100%", border: "none" }}
          allow="microphone; camera; clipboard-write; active-platform-authenticator"
        />
      </div>

      <button className="logout-button" onClick={() => navigate("/dashboard")} style={{ alignSelf: 'center', marginTop: '6px', marginBottom: '74px', zIndex: 1100 }}>
        Back
      </button>

      <Dialog open={openAlert} onClose={handleCloseAlert}>
        <DialogTitle>Access Denied</DialogTitle>
        <DialogContent>You do not have access to this Agent.</DialogContent>
        <DialogActions>
          <Button onClick={handleCloseAlert} autoFocus>
            OK
          </Button>
          <Button className="Btn" onClick={handleLogout}>
            Go Back
          </Button>
        </DialogActions>
      </Dialog>
      <Footer />
    </div>
  );
};

export default AskEnterprise;